import { useCallback, useEffect, useState } from "react";
import { format } from "date-fns";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";

export default function useTopContacts({ dateRange }) {
  const baseUrl = getHostDomain();
  const [topContacts, setTopContacts] = useState([]);
  const [status, setStatus] = useState("loading");

  const fetch = useCallback(async () => {
    if (!dateRange?.startDate || !dateRange?.endDate) return;
    setStatus("loading");
    try {
      const from = format(dateRange.startDate, "yyyy-MM-dd");
      const to = format(dateRange.endDate, "yyyy-MM-dd");
      const res = await fetchController(
        `${baseUrl}/api/v1/analytics/top_contacts?date_from=${from}&date_to=${to}&limit=5`,
        "GET"
      );
      setTopContacts(Array.isArray(res) ? res : []);
    } catch {
      setTopContacts([]);
    } finally {
      setStatus("idle");
    }
  }, [baseUrl, dateRange?.startDate, dateRange?.endDate]);

  useEffect(() => { fetch(); }, [fetch]);

  return { topContacts, status };
}
